import React from 'react';

import Header from './Header';
import Download from './Download';
import Open from './Open';

import Participants from 'components/Participants';
import Place from 'components/Place';
import PreviewDates from 'components/Dates/PreviewDates';

class Preview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      status: this.props.preview.status,
      participants: this.props.preview.participants,
      place: this.props.preview.place,
      dates: this.props.preview.dates,
    };
  }

  render() {
    return (
      <React.Fragment>
        <Header status={this.state.status} participants={this.state.participants} />
        <Participants participants={this.state.participants} />
        <Place place={this.state.place} />
        <PreviewDates status={this.state.status} dates={this.state.dates} />
        <Open />
        <Download />
      </React.Fragment>
    );
  }
}

export default Preview;
